import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Button, Dropdown, message } from 'antd';
import dayjs from 'dayjs';
import { Post as PostType } from '../../../../../store/post';
import Carousel from '../../../../Common/Carousel';
import { useAuth } from '../../../../../store/auth';
import { IconArrow } from '../../../../Common/Icon';
import User from '../../../../Common/User';

import styles from './index.module.scss';
import { FileData } from '../../../../../store/types';

interface PostParams {
  post?: PostType;
  setPost?: (post: PostType) => void;
  isHeader?: boolean;
  fileList?: FileData[];
  description?: string;
  placeName?: string;
  address?: string;
  categoryPath?: string;
}

function PostCard({
  post,
  isHeader,
  setPost,
  fileList,
  description,
  placeName,
  address,
  categoryPath,
}: PostParams) {
  const { user } = useAuth();
  const now = dayjs();
  const formattedDate = now.format('D MMMM, YYYY h:mm A');

  return (
    <div>
      {isHeader ? (
        <div className={styles.postHeader}>
          <div className={styles.title}>
            <h3>{placeName}</h3>
            <span>{address}</span>
          </div>
          <div>
            <div className={styles.titleInfo}>
              {post?.business?.id ? (
                <div className={styles.learnMore}>
                  <NavLink
                    className={styles.link}
                    to={`/business/${post?.business?.id}`}
                  >
                    <IconArrow style={{ color: '#49cf6d' }} />
                    <span className={styles.link}>More info</span>
                  </NavLink>
                </div>
              ) : null}
              <div className={styles.category}>{categoryPath}</div>
            </div>
          </div>
        </div>
      ) : null}
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <User user={user} date={formattedDate} />
        </div>
        {fileList && fileList.length > 0 ? (
          <div className={styles.carousel} style={{ width: '100%' }}>
            <Carousel files={fileList} />
          </div>
        ) : null}
        <div className={styles.descriptionWrapper}>
          <span className={styles.descrioption}>{description}</span>
        </div>
      </div>
    </div>
  );
}

export default PostCard;
